import React, { useRef, useEffect, useState } from 'react'
import { RiSendPlane2Fill } from "react-icons/ri";
import { IoMdAttach, IoMdClose } from "react-icons/io";
import { useNavigate, useParams } from "react-router-dom";
import { setLoadAppUrl } from "../features/HistorySlice";
import { ThreeDots } from 'react-loader-spinner';
import { Client, handle_file, FileData } from "@gradio/client";
import ReportApp from "./ReportApp";
import { useSelector, useDispatch } from "react-redux";
import ShareBox from "./ShareBox";
import { removeApp, changeActionS } from "../features/HistorySlice";
import { RiShareForwardLine } from 'react-icons/ri';
import { FiAlertCircle } from "react-icons/fi";
import appLogoWithName from '../Assets/appLogo_wo_icon.png'
import { BsThreeDots, BsDownload } from "react-icons/bs";
import { FaFileDownload, FaStopCircle } from "react-icons/fa";
import { MdContentCopy, MdOutlineFileDownload } from "react-icons/md";
import avatar from "../Assets/avatar.png"
import { GrClear } from "react-icons/gr";
import MarkdownView from 'react-showdown';


export default function GPTApp({ loadurl }) {
    const dispatch = useDispatch();
    const [share, setShare] = useState(false);
    const [app_id, setapp_id] = useState(null);
    const [reportapp, setreportapp] = useState(false);
    const [fileList, setfileList] = useState([]);
    const [desc, setdesc] = useState("");
    const contentRef = useRef(null);
    const shareApp = () => {
        // var appData = { ...val };
        // setShare(true);
        var myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("TOKEN", localStorage.getItem("session-token"));

        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            credentials: "include",
            redirect: "follow",
        };

        fetch("/api/v1/apps/share/" + loadurl.id, requestOptions)
            .then((response) => response.text())
            .then(async (result) => {
                try {
                    if (JSON.parse(result) && JSON.parse(result).status === 200) {
                        setapp_id(JSON.parse(result).data.id);
                        setShare(true);

                        // setSharedUrl(appData);

                        dispatch(changeActionS({ id: JSON.parse(result).data.id }));
                    }
                    else {
                        setShare(false);
                        // isDev && alert(JSON.parse(result).message);
                    }
                }
                catch (e) {
                    setShare(false);
                    //   isDev && alert(JSON.parse(result).message);
                }
            })

            .catch((error) => { setShare(false); console.log("error", error) });

    }
    const reportApp = () => {
        setreportapp(true)
    }
    const scrollableDivRef = useRef(null);
    const scrollToBottom = () => {
        if (scrollableDivRef.current) {
            setTimeout(() => {
                scrollableDivRef.current.scroll({
                    top: scrollableDivRef.current.scrollHeight + 1000,
                    behavior: "smooth",
                });
            }, 500)
        }
    };
    const { id } = useParams();
    const [chat, setchat] = useState({ chat: [] })
    const fileInputRef = useRef(null);
    const [replying, setreplying] = useState(false)
    const handleButtonClick = () => {
        if (!replying) {
            fileInputRef.current.click();
        }
    };
    const [oOptions, setoOptions] = useState(false)
    const [shareEnabled, setShareEnabled] = useState(false) // share window state

    const handleFileUpload = (event) => {
        const files = event.target.files;
        if (files) {
            var finalFiles = [...fileList, ...files]
            // Create a URL for the selected file
            setfileList(finalFiles)
            // const imageUrl = URL.createObjectURL(files);

            // var message = document.getElementById('message').value;
            // processResponse(message, file);

        }
        event.target.value = null;
    };
    const removeFile = (index) => {
        var finalFiles = [...fileList];
        finalFiles.splice(index, 1)
        // Create a URL for the selected file
        setfileList(finalFiles)
    }
    const optionButton = useRef(false);
    const filterOptions = useRef(false)
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (optionButton.current && !optionButton.current.contains(event.target)) {
                if (filterOptions.current && !filterOptions.current.contains(event.target)) {
                    setoOptions(false)
                }

            }
        };
        document.addEventListener("mousedown", handleClickOutside);
    }, [optionButton]);



    const [loading, setloading] = useState(true);
    const [client, setclient] = useState(null);
    const [api_info, setapi_info] = useState(null);
    const [examples, setexamples] = useState([]);
    const [errorMsg, seterrorMsg] = useState('');
    useEffect(() => {
        scrollToBottom();
    }, [chat, loading]);

    useEffect(() => {

        if (loadurl.id) {
            var chat = { ...loadurl, chat: [] };
            setchat(chat);
            if (document.getElementById('thumb')) {
                document.getElementById('thumb').src = loadurl.app_metadata.thumbnail;
            }

            connectClient();
        }
        else {
            setchat([]);
        }
    }, [])

    const connectClient = async () => {
        seterrorMsg("")
        let retries = 0;
        const maxRetries = 5;
        let client = null;

        while (retries < maxRetries) {
            try {
                setreplying(true);

                // Attempt to connect
                client = await Client.connect(loadurl.remote_endpoint);
                setreplying(false);

                // Filter for components and process data
                const aExampleComp = await client.config.components.filter(val => val.type == "dataset");
                if (aExampleComp && aExampleComp.length > 0) {
                    const aExamples = aExampleComp[0].props.samples.flat();
                    setexamples(aExamples);
                }
                var desc = await client.config.components[1].props.value;
                // document.getElementById("description").innerHTML = desc;
                if (desc) {
                    var regex = /<([a-z]+)(?![^>]*\/>)[^>]*>/g
                    desc = desc.replace(regex, "")
                }
                setdesc(desc)

                // Fetch app info
                const app_info = await client.view_api();
                setapi_info(app_info)
                setclient(client);

                // Exit the loop if successful
                break;

            } catch (e) {

                // Increment the retry counter
                retries++;

                // Check if retries exceed maxRetries
                if (retries >= maxRetries) {
                    // console.log("Max retries reached. Exiting...");
                    seterrorMsg("Failed to connect to the app. Try again")
                    setreplying(false);
                    break;
                }

                // Optionally, add a delay before retrying (for example, 1 second)
                await new Promise(resolve => setTimeout(resolve, 3000));
            }
        }
    }
    const sendChat = async () => {
        if (!replying) {
            var message = document.getElementById('message').value;
            if (fileList.length > 0) {
                processResponse(message, fileList);
            }
            else {
                processResponse(message)
            }

        }

    }
    const filterArray = (arr) => {
        return arr.slice(1) // start from the second element
            .filter(item => Array.isArray(item) && item.length > 0); // filter non-empty arrays
    };
    const processResponse = async (message, aFiles, parameters) => {
        var aChat = { ...chat };
        var blob = null;

        if (aFiles && aFiles.length > 0) {
            var aBlob = [];
            var fileList = [];
            for await (const file of aFiles) {
                aBlob.push(new Blob([file], { type: file.type }));
                // aBlob.push(handle_file(file));
                fileList.push(file.name)
            }

            // aChat.chat.push({ msg: "File Uploaded Successsfully: " + file.name, owner: 'user', type: 'text' })
        }


        document.getElementById('message').value = "";
        setreplying(true);
        var chatbot = [];
        aChat.chat.map(val => {
            if (val.owner == "user") {
                if (val.isDummy) {
                    chatbot.push([val.actualMsg, null]);
                }
                else {
                    chatbot.push([val.msg, null]);
                }

            }
            else if (val.owner == "bot") {
                chatbot.push([null, val.msg]);
            }
        })
        try {
            if (aBlob && aBlob.length > 0) {
                if (api_info.named_endpoints["/query_message"]) {

                    const resp = client.submit("/query_message", {
                        file: aFiles,
                        prompt: ""
                    });
                    for await (const message of resp) {
                        aChat.chat.push({ actualMsg: message.data[0][1][0], owner: 'user', type: 'text', isDummy: true, msg: "File Uploaded Successsfully: " + fileList.join(",") });
                        chatbot.push(message.data[0][1]);
                    }
                    setchat({ ...aChat });
                }
                else {
                    aFiles.map(val => {
                        aChat.chat.push({ msg: "File Uploaded Successsfully: " + val.name, owner: 'user', type: 'text' })
                    })

                }


            }
            if (message) {
                aChat.chat.push({ msg: message, owner: 'user', type: 'text' });
                setchat({ ...aChat });
            }
            setfileList([])
            window.job = client.submit("/bot", {
                history: chatbot,
                userfile: aBlob && aBlob.length > 0 ? aBlob : null,
                query: message,

            });

            // const job = client.submit("/bot", {
            //     query: message,

            // });

            var files = null;
            let firstIteration = true;
            var otherItems = null;
            for await (const msg of window.job) {


                // console.log("msg", msg);
                otherItems = filterArray(msg.data);
                if (otherItems && otherItems.length > 0) {
                    // console.log("otherItems", otherItems)
                }
                var difference = msg.data[0].filter(item2 => !chatbot.some(item1 =>
                    item1[0] === item2[0] && item1[1] === item2[1]
                ));
                // console.log("difference", difference);
                // console.log("parseResponse", parseResponse(difference));
                var innerMsg = parseResponse(difference);
                // if (Array.isArray(innerMsg)) {
                //     innerMsg = innerMsg.join("\n\n")
                // }
                if (firstIteration) {
                    aChat.chat.push({ owner: 'bot', type: "text", msg: innerMsg.text });
                    firstIteration = false; // Set it to false after the first log
                }
                else {
                    aChat.chat[aChat.chat.length - 1].msg = innerMsg.text;
                }

                files = innerMsg.files;
                setchat({ ...aChat });
            }

            files.map(val => {
                var file = handle_file(val.file.url);
                var file_type = getFileType(val.file.mime_type)
                aChat.chat.push({ url: val.file.url.replace("http:", "https:"), owner: 'bot', type: file_type, msg: JSON.stringify({ "file": file, "alt_text": "Media" }), file_type: val.file.mime_type })
            });
            if (files.length == 0) {
                otherItems.map(val => {
                    var file = handle_file(val[0].url);
                    var file_type = getFileType(val[0].mime_type)
                    aChat.chat.push({ url: val[0].url.replace("http:", "https:"), owner: 'bot', type: file_type, msg: JSON.stringify({ "file": file, "alt_text": "Media" }), file_type: val[0].mime_type })
                });
            }
            setchat({ ...aChat });

            setreplying(false);
        }
        catch (e) {
            console.log("error", e)
            setreplying(false);
        }

    }
    function stopChat() {
        if (window.job) {

            window.job.cancel();
            window.job = undefined;
        }
    }
    function getFileType(mimeType) {
        const imageTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/webp', 'image/svg+xml'];
        const audioTypes = ['audio/mpeg', 'audio/wav', 'audio/ogg', 'audio/aac', 'audio/flac', 'audio/mp3'];
        const videoTypes = ['video/mp4', 'video/webm', 'video/ogg', 'video/x-msvideo', 'video/x-ms-wmv'];

        if (imageTypes.includes(mimeType)) {
            return 'image';
        } else if (audioTypes.includes(mimeType)) {
            return 'audio';
        } else if (videoTypes.includes(mimeType)) {
            return 'video';
        } else {
            return 'file';
        }
    }
    const onCopyText = async (textToCopy) => {
        // Navigator clipboard api needs a secure context (https)
        if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(textToCopy);
        } else {
            // Use the 'out of viewport hidden text area' trick
            const textArea = document.createElement("textarea");
            textArea.value = textToCopy;

            // Move textarea out of the viewport so it's not visible
            textArea.style.position = "absolute";
            textArea.style.left = "-999999px";

            document.body.prepend(textArea);
            textArea.select();

            try {
                document.execCommand('copy');
            } catch (error) {
                console.error(error);
            } finally {
                textArea.remove();
            }
        }
    };
    const parseResponse = (response) => {
        const files = [];
        let text = [];

        // Iterate through the response array
        for (let i = 0; i < response.length; i++) {
            const currentArray = response[i];

            // Check if the second element is a string (text)
            if (currentArray[1]) {
                if (typeof currentArray[1] === 'string') {
                    text.push(currentArray[1]);
                }

                // Check if the second element is an object with a file key
                if (typeof currentArray[1] === 'object' && currentArray[1].hasOwnProperty('file')) {
                    files.push(currentArray[1]);
                }
            }
        }
        text = text.join(",");
        // Return the collected text and files
        return { text, files };
    }
    const downloadChat = async () => {
        setoOptions(false);
        document.body.style.cursor = "progress";
        try {
            const allDivs = Array.from(contentRef.current.childNodes).slice(2)
            const modifiedDivs = [];

            for (const ele of allDivs) {
                // Clone the div element to avoid modifying the original
                const clonedDiv = ele.cloneNode(true);


                if (clonedDiv.querySelector('img')) {
                    const imgElement = clonedDiv.querySelector('img');
                    // Convert the image src to Base64 and set it in the cloned element
                    var bSrc = await convertImageToBase64(imgElement.src);
                    imgElement.src = bSrc;
                    if (imgElement.nextElementSibling.tagName == 'A') {
                        imgElement.nextElementSibling.remove()

                    }
                }
                else if (clonedDiv.querySelector('audio')) {
                    const imgElement = clonedDiv.querySelector('audio');
                    // Convert the image src to Base64 and set it in the cloned element
                    var bSrc = await convertImageToBase64(imgElement.src);
                    imgElement.children[0].src = bSrc;

                }
                else if (clonedDiv.querySelector('video')) {
                    const imgElement = clonedDiv.querySelector('video');
                    // Convert the image src to Base64 and set it in the cloned element
                    var bSrc = await convertImageToBase64(imgElement.src);
                    imgElement.children[0].src = bSrc;

                }
                else if (clonedDiv.querySelector('.fileDownload')) {
                    const imgElement = clonedDiv.querySelector('.fileDownload');
                    // Convert the image src to Base64 and set it in the cloned element
                    var bSrc = await convertImageToBase64(imgElement.src);
                    imgElement.href = bSrc;

                }


                // Push the outerHTML of the modified cloned div into the array
                modifiedDivs.push(clonedDiv.outerHTML);
            }

            // Combine the HTML of the modified divs
            const innerContent = modifiedDivs.join('\n');
            //     const content = `
            //     <div style="max-width: 700px; margin: 0 auto;">
            //       ${innerContent}
            //     </div>
            //   `;
            const content = document.createElement("div");
            content.innerHTML = innerContent;
            content.style.maxWidth = "700px";
            content.style.padding = "30px";
            content.style.margin = "0 auto"; // Move it off-screen
            document.body.appendChild(content);
            window.html2canvas(content).then(canvas => {
                const imgData = canvas.toDataURL('image/png'); // Convert canvas to image data
                const pdf = new window.jspdf.jsPDF(); // Initialize jsPDF
                const imgProps = pdf.getImageProperties(imgData);

                const pdfWidth = pdf.internal.pageSize.getWidth();
                const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

                let pageHeight = pdf.internal.pageSize.getHeight();
                let position = 0;

                // Add pages as needed
                while (position < pdfHeight) {
                    pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, pdfHeight);
                    position -= pageHeight;

                    // Add a new page if content is still remaining
                    if (position < pdfHeight) {
                        pdf.addPage();
                        position = 0; // Reset position for next page
                    }
                }

                pdf.save(loadurl.app_name + '.pdf'); // Save PDF
                document.body.removeChild(content);
                document.body.style.cursor = "default";
            });
        }
        catch (e) {
            document.body.style.cursor = "default";
        }
    }
    const convertImageToBase64 = async (url) => {
        try {
            // Fetch the image as a blob
            const response = await fetch(url);
            const blob = await response.blob();

            // Read the blob as a Base64 string
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = () => reject("Failed to convert image to Base64");
                reader.readAsDataURL(blob);
            });
        } catch (error) {
            console.error("Error converting image to Base64:", error);
            throw error;
        }
    }
    const clearChat = async () => {
        var aChat = { ...chat };
        aChat.chat = []
        setchat(aChat);
        try {
            var resp = await client.predict("/reset_session_id");
            console.log(resp);
            setoOptions(false)
        }
        catch (e) {
            setoOptions(false)
        }

    }
    const downloadHTML = async () => {
        // const htmlContent = generateHTML();
        setoOptions(false);
        const allDivs = Array.from(contentRef.current.childNodes).slice(2)
        const modifiedDivs = [];

        for (const ele of allDivs) {
            // Clone the div element to avoid modifying the original
            const clonedDiv = ele.cloneNode(true);

            if (clonedDiv.querySelector('img')) {
                const imgElement = clonedDiv.querySelector('img');
                // Convert the image src to Base64 and set it in the cloned element
                var bSrc = await convertImageToBase64(imgElement.src);
                imgElement.src = bSrc;
                if (imgElement.nextElementSibling.tagName == 'A') {
                    imgElement.nextElementSibling.remove()

                }
            }
            else if (clonedDiv.querySelector('audio')) {
                const imgElement = clonedDiv.querySelector('audio');
                // Convert the image src to Base64 and set it in the cloned element
                var bSrc = await convertImageToBase64(imgElement.querySelector("source").src);
                imgElement.children[0].src = bSrc;

            }
            else if (clonedDiv.querySelector('video')) {
                const imgElement = clonedDiv.querySelector('video');
                // Convert the image src to Base64 and set it in the cloned element
                var bSrc = await convertImageToBase64(imgElement.querySelector("source").src);
                imgElement.children[0].src = bSrc;
            }
            else if (clonedDiv.querySelector('.fileDownload')) {
                const imgElement = clonedDiv.querySelector('.fileDownload');
                // Convert the image src to Base64 and set it in the cloned element
                var bSrc = await convertImageToBase64(imgElement.href);
                imgElement.href = bSrc;

            }

            // Push the outerHTML of the modified cloned div into the array
            modifiedDivs.push(clonedDiv.outerHTML);
        }

        // Combine the HTML of the modified divs
        const innerContent = modifiedDivs.join('\n');
        const content = `
        <div style="max-width: 700px; margin: 0 auto;">
          ${innerContent}
        </div>
      `;
        const blob = new Blob([content], { type: 'text/html' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = loadurl.app_name + '.html';
        a.click();
        URL.revokeObjectURL(url); // Clean up URL object
    };
    const submitRequest = (event) => {
        if (!event.shiftKey && event.key === "Enter") {
            // 👇 Get input value
            sendChat();
        }
    }

    const convertMarkdownLinksToHTML = (text) => {
        return text.replace(/\[([^\]]+)\]\(([^\)]+)\)/g, '<a target="blank" style="color:#ff6701;text-decoration:underline" href="$2">$1</a>');
    }
    return (
        <div style={{ position: 'absolute', top: 0, left: 0, zIndex: 1000, backgroundColor: 'rgba(0,0,0,0.95', width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            {reportapp && <ReportApp appId={loadurl.id} setVisible={(val) => {
                setreportapp(false)
            }} />}

            {share && <ShareBox mode="light" setShare={setShare} app_id={app_id} app_name={loadurl?.app_name} app_details={loadurl} showGallery={true} desc={desc} />}
            <div className={`flex`} style={{ flexDirection: 'column', height: '100%', width: '100%', alignItems: 'center' }}>


                <div style={{
                    backgroundColor: 'rgb(255 255 255)',
                    borderRadius: 10,
                    overflowY: 'auto',
                    maxHeight: '100%',
                    maxWidth: 640,
                    width: '100%',
                    height: '100%',
                    display: "flex"
                }}>
                    <div style={{ flex: 1, alignItems: 'center', width: '100%', display: 'flex', flexDirection: 'column', position: "relative" }}>
                        <div ref={optionButton} style={{ display: "flex", width: "100%", justifyContent: "flex-end", gap: 10, paddingRight: 5, paddingTop: 5 }}>
                            <BsThreeDots size={25} onClick={() => setoOptions(true)} style={{ cursor: "pointer" }} />

                            <IoMdClose size={25} style={{ cursor: "pointer" }} onClick={() => {
                                dispatch(setLoadAppUrl(''));
                            }} />

                        </div>
                        {oOptions && (
                            <div className="optionBlock" ref={filterOptions}>
                                <div style={{ display: "flex", alignItems: "center", gap: 5, cursor: "pointer", fontWeight: 300, paddingTop: 5, paddingBottom: 5 }} onClick={() => {
                                    reportApp()
                                }}>
                                    <FiAlertCircle title="Report app" style={{ cursor: 'pointer', color: 'black' }} size={18} ></FiAlertCircle>
                                    Report
                                </div>
                                <div style={{ display: "flex", alignItems: "center", gap: 5, cursor: "pointer", fontWeight: 300, paddingTop: 5, paddingBottom: 5 }} onClick={() => {
                                    shareApp()
                                }}>
                                    <RiShareForwardLine style={{ cursor: 'pointer', color: 'black' }} size={18}></RiShareForwardLine>
                                    Share
                                </div>
                                <div style={{ display: "flex", alignItems: "center", gap: 5, cursor: "pointer", fontWeight: 300, paddingTop: 5, paddingBottom: 5 }} onClick={() => {
                                    downloadHTML()
                                }}>
                                    <BsDownload style={{ cursor: 'pointer', color: 'black' }} size={18}></BsDownload>
                                    Download Chat
                                </div>
                                <div style={{ display: "flex", alignItems: "center", gap: 5, cursor: "pointer", fontWeight: 300, paddingTop: 5, paddingBottom: 5 }} onClick={() => {
                                    clearChat()
                                }}>
                                    <GrClear title="Report app" style={{ cursor: 'pointer', color: 'black' }} size={18} ></GrClear>
                                    Clear Chat
                                </div>
                            </div>
                        )}
                        <div id='chatDivBox' className='chatDivBox' ref={scrollableDivRef} style={{ width: '100%', flex: 1, display: 'flex', flexDirection: 'column', overflowY: 'auto', alignItems: 'center', marginBottom: 0, padding: 20, paddingBottom: 0 }}>
                            <div style={{ maxWidth: 700, width: '100%', flex: 1, display: 'flex', flexDirection: 'column' }} ref={contentRef}>
                                <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end', alignItems: 'center', flexDirection: 'column' }}>
                                    <img id='thumb' width='100px' style={{ borderRadius: '50%' }} />
                                    <h1>{loadurl?.app_name}</h1>
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 6, marginTop: 5, fontWeight: 300 }}>by <img style={{ height: 25, marginTop: 5 }} src={appLogoWithName} alt="appstorm-logo" /></div>
                                    <h5 id="description" style={{ color: "#000000a1", marginTop: 20, marginBottom: 20, fontWeight: 400, fontSize: 14, textAlign: "center" }}>{desc}</h5>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                    <div style={{ display: 'flex', flexDirection: 'row', padding: 10, alignItems: "center", justifyContent: "center", flexWrap: "wrap" }}>
                                        {examples.map((val, index) => {
                                            return (
                                                <button disabled={replying} key={index} onClick={() => {
                                                    document.getElementById("message").value = val;
                                                    document.getElementById("message").focus();
                                                    // sendChat();
                                                }} style={{ display: 'flex', flexDirection: 'column', color: 'black', width: "45%", padding: '6px 15px', borderRadius: 5, border: '1px solid #0000004d', background: 'white', cursor: 'pointer', textAlign: 'center', lineHeight: '20px', margin: 5, fontSize: 15, alignItems: "center" }}><span style={{ fontWeight: 400 }}>{val}</span></button>)
                                        })}
                                    </div>
                                </div>
                                {chat?.chat.length > 0 && chat.chat.map((val, index) => {
                                    return <div className="chatSec" key={index} style={{ display: 'flex', flexDirection: 'column', alignItems: 'start', marginTop: 20 }}>
                                        <div style={{ display: 'flex', flexDirection: 'column', width: "100%" }}>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: "space-between" }}>
                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    <div style={{ width: 30, height: 30, borderRadius: '50%', marginRight: 10, backgroundImage: `url(${val.owner == 'user' ? avatar : loadurl?.app_metadata.thumbnail})`, backgroundSize: 'contain' }}></div>
                                                    <span style={{ color: 'black', fontWeight: '600', fontSize: 20 }}>{val.owner == 'user' ? 'You' : loadurl?.app_name}</span>
                                                </div>
                                                <div style={{ cursor: "pointer" }} className="copyBTn" onClick={() => onCopyText(val.msg)}><MdContentCopy color={"#00000057"} /></div>
                                            </div>
                                            {val.type == 'text' && <div className='chatBox' style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                color: '#000',
                                                marginTop: 10,
                                                marginLeft: 40
                                            }}>

                                                {val.msg && val.msg.split('\n\n').map((text, index) => (
                                                    <div className="copyDiv" key={index} style={{ marginTop: index == 0 ? 0 : 20, display: "flex", alignItems: "flex-start", justifyContent: "space-between", width: "100%", wordBreak: "break-all", whiteSpace: "normal" }}>
                                                        {/* <div dangerouslySetInnerHTML={{ __html: convertMarkdownLinksToHTML(text) }}></div> */}
                                                        <MarkdownView
                                                            className='markdown'
                                                            markdown={text}
                                                            options={{ tables: true, emoji: true, openLinksInNewWindow: true, underline: true, moreStyling: true }}
                                                        />
                                                    </div>
                                                ))}
                                            </div>}
                                        </div>

                                        {/* here is the Image */}
                                        {val.type == 'image' && <div className='chatBox' style={{
                                            padding: 10,
                                            marginTop: 0,
                                            display: 'flex',
                                            justifyContent: 'flex-start',
                                            alignItems: 'flex-start',
                                            gap: '0.5rem',
                                            marginLeft: 40
                                        }}>

                                            <img style={{ borderRadius: 5, width: "100%", maxWidth: 512 }} src={val.url} />
                                            <a href={val.url} target="_blank" ><MdOutlineFileDownload color='#727272' size={20} /></a>

                                        </div>}

                                        {/* here is the video */}
                                        {val.type == 'video' && <div className='chatBox' style={{
                                            padding: 10,
                                            marginTop: 0,
                                            display: 'flex',
                                            justifyContent: 'centerr',
                                            gap: '0.5rem',
                                            marginLeft: 40
                                        }}>

                                            <video height="200" controls>
                                                {/* Replace 'your-video.mp4' with the actual path to your video file */}
                                                <source src={val.url} type="video/mp4" />
                                                Your browser does not support the video tag.
                                            </video>
                                            <a href={val.url} target="_blank" ><MdOutlineFileDownload color='#727272' size={20} /></a>
                                        </div>}
                                        {val.type == 'audio' && <div className='chatBox' style={{
                                            padding: 10,
                                            marginTop: 0,
                                            display: 'flex',
                                            justifyContent: 'centerr',
                                            gap: '0.5rem',
                                            marginLeft: 40
                                        }}>
                                            <audio controls>
                                                <source src={val.url} type={val.file_type} />
                                            </audio>
                                            <a href={val.url} target="_blank" ><MdOutlineFileDownload color='#727272' size={20} /></a>
                                        </div>}
                                        {val.type == 'file' && <div className='chatBox' style={{
                                            padding: 10,
                                            marginTop: 0,
                                            display: 'flex',
                                            justifyContent: 'centerr',
                                            gap: '0.5rem',
                                            marginLeft: 40
                                        }}>
                                            <a className='fileDownload' href={val.url} download="true" target="_blank">
                                                <FaFileDownload size={60} color="#fe7e00" />
                                            </a>
                                        </div>}



                                    </div>
                                })}
                            </div>
                            <div style={{ marginLeft: 25 }}>
                                <ThreeDots
                                    visible={replying}
                                    height="80"
                                    width="80"
                                    color="#fe7e00"
                                    radius="9"
                                    ariaLabel="three-dots-loading"
                                    wrapperStyle={{}}
                                />
                            </div>
                            <div>{errorMsg}</div>
                        </div>

                        <div className='messageBox' style={{
                            display: 'flex',
                            width: '100%',
                            maxWidth: 700,
                            justifyContent: 'center',
                            alignItems: 'center',
                            background: 'white',
                            flexDirection: 'column',
                            padding: 20,
                            paddingBottom: 10
                        }}>
                            {fileList.length > 0 && <div className='fileBox-container'>

                                {fileList.map((val, index) => {
                                    return <div key={index} className='fileBox'><p>{val.name}</p><div className='closeContainer' onClick={() => removeFile(index)}><IoMdClose size={15} color="white" /></div></div>
                                })}

                            </div>}

                            <div style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                gap: 10,
                                color: 'white',
                                border: '1px solid #00000061',
                                padding: 10,
                                borderRadius: 10,
                                boxShadow: '6px 8px 20px 0px #00000054',
                                width: '100%',
                                background: 'white'
                            }}>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: 10, cursor: 'pointer' }}>
                                    <input
                                        type="file"
                                        ref={fileInputRef}
                                        multiple
                                        style={{ display: 'none' }}
                                        onChange={handleFileUpload}
                                    />
                                    <IoMdAttach color='black' size={20} disabled={replying} onClick={handleButtonClick} />
                                </div>
                                <div style={{
                                    flex: 1, border: '1px solid #FFF',
                                    borderRadius: 25,
                                }}>
                                    <input
                                        className="outline-none"
                                        id="message"
                                        type="text"
                                        placeholder="Type a message"
                                        style={{
                                            background: 'transparent',
                                            border: 0,
                                            fontSize: 15,
                                            color: 'black',
                                            width: '100%',
                                        }}
                                        onKeyDown={submitRequest}
                                        disabled={replying}
                                    />
                                </div>
                                {!replying ? <RiSendPlane2Fill color='black' onClick={sendChat} /> :
                                    <FaStopCircle color='black' onClick={stopChat} />}

                            </div>

                        </div>
                    </div>
                </div>
            </div>


        </div >
    )
}
